module.exports = __webpack_public_path__ + "img/album01_04.84dff525.jpg";